import React from 'react';
import { WithIcon } from './WithIcon';

export const IconGalleryTrace = WithIcon(
  'GalleryTrace',
  '0 0 20 20',
  <path d="M17.6863 13.3267h.9804V3.3334H5.3529v1h12.3334v8.9933ZM15.4837 6.5H2v10.1667h13.4837V6.5Zm-.9804 1v8.16H2.9803V7.5h11.523Z" />
);
